import { render, staticRenderFns } from "./swiperItem.vue?vue&type=template&id=5b2a74c2&scoped=true&"
import script from "./swiperItem.vue?vue&type=script&lang=js&"
export * from "./swiperItem.vue?vue&type=script&lang=js&"
import style0 from "./swiperItem.vue?vue&type=style&index=0&id=5b2a74c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a74c2",
  null
  
)

export default component.exports